import React, { useRef, useState } from 'react';
// DESIGN SYSTEM & COMPONENTS
import TestCycleReactTable from './testCycle/TestCycleReactTable';
import SelectedTableFilters from '../../components/filtering/SelectedTableFilters';
import { SidePaneRightContent, TOP_HEADING_SIZE } from '../../components/Layout';
import { Heading } from '../../designSystem/DesignSystem';
// HELPER & CONSTANTS IMPORTS
import { ENTITY_TYPES } from '../../constants';
import { getArtifactName } from '../../helpers/ArtifactNameHelper';
// HOOKS & API IMPORTS
import UseProjectConfig from '../../hooks/UseProjectConfig';
import UseProjectUsers from '../../hooks/UseProjectUsers';

const TestPlanningDashboard = (props) => {
  const { projectId } = props;
  const projectConfig = UseProjectConfig(projectId);
  const users = UseProjectUsers(projectId);

  const [allFilters, setAllFilters] = useState({});
  const [refreshTable, setRefreshTable] = useState(true);

  const centerRef = useRef(); // General center height
  const centerHeight = centerRef?.current?.clientHeight;

  const tableHeight = centerHeight - centerRef?.current?.childNodes[0]?.clientHeight - 65; // Table Height

  return (
    <SidePaneRightContent overflow={true}>
      <SidePaneRightContent.Top>
        <Heading
          type={TOP_HEADING_SIZE}
          text={`${getArtifactName(projectConfig, ENTITY_TYPES.TEST_CYCLE)}`}
        />
      </SidePaneRightContent.Top>
      <SidePaneRightContent.Main>
        {projectId && (
          <>
            <SidePaneRightContent.Center ref={centerRef}>
              <SelectedTableFilters
                allFilters={allFilters}
                setAllFilters={setAllFilters}
                entityType={ENTITY_TYPES.TEST_CYCLE}
                setRefreshTable={setRefreshTable}
              />
              <TestCycleReactTable
                filter={{ ...allFilters, projectId }}
                refreshStatus={refreshTable}
                setRefreshStatus={setRefreshTable}
                users={users}
                height={tableHeight}
                projectConfig={projectConfig}
              />
            </SidePaneRightContent.Center>
          </>
        )}
      </SidePaneRightContent.Main>
    </SidePaneRightContent>
  );
};

export default TestPlanningDashboard;
